import MetaTags from "react-meta-tags"
import React, { useEffect, useRef, useState } from "react"
import { Link } from "react-router-dom"
import {
  Row,
  Label,
  Button,
  Container,
  Card,
  CardBody,
  Modal,
  Table,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  UncontrolledDropdown,
  Alert,
  Col,
} from "reactstrap"

import { AvForm, AvField } from "availity-reactstrap-validation"

import { withRouter } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import {
  addUser,
  deleteUser,
  editUser,
  getUsers,
  resetPasswordUser,
  resetUserFlag,
  setUserPage,
  setUserTotalPage,
} from "store/actions"
import { toast } from "react-toastify"

import { userModel } from "helpers/models/UserModel"
import { userConstants } from "constants/user"
import AvInput from "availity-reactstrap-validation/lib/AvInput"
import Paginate from "components/Common/Paginate"
import Loading from "components/Common/Loading"

const pageSize = 10

const UserList = props => {
  const dispatch = useDispatch()
  const paginateRef = useRef(null)
  const {
    currentUser,
    userList,
    userError,
    userSuccess,
    loading,
    loadingSubmit,
    page,
    totalPage,
  } = useSelector(state => ({
    currentUser: state.Login.user,
    userList: state.Users.users,
    userError: state.Users.error,
    userSuccess: state.Users.success,
    loading: state.Users.loading,
    loadingSubmit: state.Users.loadingSubmit,
    page: state.Users.page,
    totalPage: state.Users.totalPage,
  }))

  const [modelUser, setModelUser] = useState({ ...userModel })
  const [mode, setMode] = useState(userConstants.OPERATION.ADD)

  const [keyword, setKeyword] = useState("")
  const [isSearch, setIsSearch] = useState(false)
  const [userSearchList, setUserSearchList] = useState([])
  const [userListShow, setUserListShow] = useState([])

  useEffect(() => {
    dispatch(getUsers())
  }, [])

  useEffect(() => {
    if (userSuccess) {
      toast.dismiss()
      toast.success(userSuccess)
      setModalUser(false)
      setModalConfirmDelete(false)
      dispatch(resetUserFlag())
      dispatch(getUsers())
    }
  }, [userSuccess])

  useEffect(() => {
    if (keyword) {
      onSearch()
    } else {
      setUserListShow([
        ...userList.slice((page - 1) * pageSize, page * pageSize),
      ])
    }
  }, [userList])

  useEffect(() => {
    if (isSearch) {
      setUserListShow([
        ...userSearchList.slice((page - 1) * pageSize, page * pageSize),
      ])
    } else {
      setUserListShow([
        ...userList.slice((page - 1) * pageSize, page * pageSize),
      ])
    }
  }, [userSearchList])

  function sliceUserListShow() {
    setUserListShow([
      ...(isSearch ? userSearchList : userList).slice(
        (page - 1) * pageSize,
        page * pageSize
      ),
    ])
  }

  function onSearch() {
    setIsSearch(true)
    setUserSearchList([
      ...userList.filter(user => {
        if (
          (user.first_name || "").includes(keyword) ||
          (user.last_name || "").includes(keyword) ||
          (user.email || "").includes(keyword) ||
          (user.tel || "").includes(keyword) ||
          (user.agent_name || "").includes(keyword)
        )
          return user
      }),
    ])
  }

  function clearSearch() {
    setIsSearch(false)
    setKeyword("")
    dispatch(setUserPage(1))
    setUserSearchList([])
  }

  function handleValidSubmit(event, values) {
    switch (mode) {
      case userConstants.OPERATION.ADD:
        dispatch(addUser(modelUser))
        break
      case userConstants.OPERATION.EDIT:
        dispatch(editUser(modelUser))
        break
      case userConstants.OPERATION.RESET_PASSWORD:
        dispatch(resetPasswordUser(modelUser))
        break
      default:
        setModalUser(false)
        resetUser()
        dispatch(resetUserFlag())
    }
  }

  function handleAddUser() {
    setMode(userConstants.OPERATION.ADD)
    toggleModalUser()
  }

  function handleEditUser(user) {
    setMode(userConstants.OPERATION.EDIT)
    toggleModalUser()
    setModelUser({ ...user, password: "", re_password: "" })
  }

  function handleResetPasswordUser(user) {
    setMode(userConstants.OPERATION.RESET_PASSWORD)
    toggleModalUser()
    setModelUser({ ...user, password: "", re_password: "" })
  }

  function handleDeleteUser(user) {
    toggleModalConfirmDelete()
    setModelUser({ ...user })
  }

  function handleDeleteUserSubmit() {
    dispatch(deleteUser(modelUser))
  }

  const [modalUser, setModalUser] = useState(false)
  const [modalConfirmDelete, setModalConfirmDelete] = useState(false)

  function toggleModalUser() {
    resetUser()
    dispatch(resetUserFlag())
    setModalUser(!modalUser)
  }

  function toggleModalConfirmDelete() {
    resetUser()
    dispatch(resetUserFlag())
    setModalConfirmDelete(!modalConfirmDelete)
  }

  function resetUser() {
    setModelUser({ ...userModel })
  }

  function titleModal() {
    switch (mode) {
      case userConstants.OPERATION.ADD:
        return "Create User"
      case userConstants.OPERATION.EDIT:
        return "Edit User"
      case userConstants.OPERATION.RESET_PASSWORD:
        return "Reset Password"
      default:
        return ""
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Hast | User Setting</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <div className="d-flex  align-items-center flex-wrap mt-2 mb-3">
            <h4 className="mb-0 font-size-16">User Setting</h4>

            <div style={{ marginLeft: "auto" }}>
              <Button
                color="primary"
                outline
                className=""
                onClick={() => {
                  handleAddUser()
                }}
              >
                Create User
              </Button>
            </div>
            <Modal isOpen={modalUser} centered={true}>
              <div className="modal-header">
                <h5 className="modal-title mt-0">{titleModal()}</h5>
                <button
                  type="button"
                  onClick={() => {
                    setModalUser(false)
                  }}
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  disabled={loadingSubmit}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {userError ? <Alert color="danger">{userError}</Alert> : null}
                <AvForm
                  className="form-horizontal"
                  onValidSubmit={(e, v) => {
                    handleValidSubmit(e, v)
                  }}
                >
                  <div className="form-group mb-3">
                    <AvField
                      name="email"
                      label="Email"
                      value={modelUser.email}
                      className="form-control mb-3"
                      placeholder="Enter Email"
                      type="text"
                      disabled={
                        mode === userConstants.OPERATION.EDIT ||
                        mode === userConstants.OPERATION.RESET_PASSWORD
                      }
                      onChange={e =>
                        setModelUser({
                          ...modelUser,
                          email: e.target.value,
                        })
                      }
                    />
                    {(mode === userConstants.OPERATION.ADD ||
                      mode === userConstants.OPERATION.RESET_PASSWORD) && (
                      <>
                        <AvField
                          name="password"
                          label={
                            mode === userConstants.OPERATION.ADD
                              ? "Password"
                              : "New Password"
                          }
                          value={modelUser.password}
                          className="form-control mb-3"
                          placeholder={
                            mode === userConstants.OPERATION.ADD
                              ? "Enter Password"
                              : "Enter New Password"
                          }
                          type="password"
                          onChange={e =>
                            setModelUser({
                              ...modelUser,
                              password: e.target.value,
                            })
                          }
                        />
                        <AvField
                          name="re_password"
                          label={
                            mode === userConstants.OPERATION.ADD
                              ? "Re-Password"
                              : "Re-New Password"
                          }
                          value={modelUser.re_password}
                          className="form-control mb-3"
                          placeholder={
                            mode === userConstants.OPERATION.ADD
                              ? "Enter Re-Password"
                              : "Enter Re-New Password"
                          }
                          type="password"
                          onChange={e =>
                            setModelUser({
                              ...modelUser,
                              re_password: e.target.value,
                            })
                          }
                        />
                      </>
                    )}
                    {(mode === userConstants.OPERATION.ADD ||
                      mode === userConstants.OPERATION.EDIT) && (
                      <>
                        <AvField
                          name="first_name"
                          label="First Name"
                          value={modelUser.first_name || ""}
                          className="form-control mb-3"
                          placeholder="Enter First Name"
                          type="text"
                          onChange={e =>
                            setModelUser({
                              ...modelUser,
                              first_name: e.target.value,
                            })
                          }
                        />
                        <AvField
                          name="last_name"
                          label="Last Name"
                          value={modelUser.last_name || ""}
                          className="form-control mb-3"
                          placeholder="Enter Last Name"
                          type="text"
                          onChange={e =>
                            setModelUser({
                              ...modelUser,
                              last_name: e.target.value,
                            })
                          }
                        />
                        <AvField
                          name="tel"
                          label="Tel."
                          value={modelUser.tel || ""}
                          className="form-control mb-3"
                          placeholder="Enter Tel."
                          type="text"
                          onChange={e =>
                            setModelUser({
                              ...modelUser,
                              tel: e.target.value,
                            })
                          }
                        />
                        <AvField
                          name="agent_name"
                          label="Agent Name"
                          value={modelUser.agent_name || ""}
                          className="form-control mb-3"
                          placeholder="Enter Agent Name"
                          type="text"
                          onChange={e =>
                            setModelUser({
                              ...modelUser,
                              agent_name: e.target.value,
                            })
                          }
                        />
                        <AvField
                          type="select"
                          name="is_admin"
                          label="Permission"
                          value={modelUser.is_admin}
                          onChange={e =>
                            setModelUser({
                              ...modelUser,
                              is_admin: e.target.value,
                            })
                          }
                        >
                          <option value="false">User</option>
                          <option value="true">Admin</option>
                        </AvField>
                      </>
                    )}
                  </div>
                  <div className="mb-2 row">
                    <div className="col-6">
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => {
                          toggleModalUser()
                        }}
                        disabled={loadingSubmit}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="col-6 text-end">
                      <Button
                        type="submit"
                        color="success"
                        disabled={loadingSubmit}
                      >
                        Submit
                      </Button>
                    </div>
                  </div>
                </AvForm>
              </div>
            </Modal>
          </div>
          <Row className="mb-3">
            <Col className="pe-0">
              <AvForm
                className="d-flex align-items-center"
                onValidSubmit={(e, v) => {
                  setKeyword(v.keyword)
                  onSearch()
                }}
              >
                <div className="search-box" style={{ width: "100%" }}>
                  <div className="position-relative">
                    <AvInput
                      type="text"
                      name="keyword"
                      className="form-control rounded"
                      placeholder="Search..."
                      value={keyword || ""}
                      onChange={e => setKeyword(e.target.value)}
                      disabled={loading}
                    />
                    <i className="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </AvForm>
            </Col>
            <Col>
              <Button
                color="primary"
                className="me-1"
                onClick={() => onSearch()}
                disabled={loading}
              >
                Search
              </Button>
              <Button
                type="button"
                color="secondary"
                outline
                onClick={() => clearSearch()}
                disabled={loading}
              >
                Clear
              </Button>
            </Col>
          </Row>
          <Card>
            <CardBody>
              <div
                className="table-responsive file-manager"
                style={{ overflowX: "visible", overflowY: "visible" }}
              >
                <Table className="table align-middle table-nowrap table-hover">
                  <thead>
                    <tr className="text-center">
                      <th scope="col" width="25%">
                        Name
                      </th>
                      <th
                        scope="col"
                        width="25%"
                        className="d-none d-md-table-cell"
                      >
                        Email
                      </th>
                      <th
                        scope="col"
                        width="20%"
                        className="d-none  d-md-table-cell"
                      >
                        Tel.
                      </th>
                      <th
                        scope="col"
                        width="25%"
                        className="d-none  d-lg-table-cell"
                      >
                        Agent Name
                      </th>
                      <th width="5%"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading && (
                      <tr>
                        <td colSpan={5}>
                          <Loading />
                        </td>
                      </tr>
                    )}
                    {!loading && (
                      <React.Fragment>
                        {userListShow.length === 0 && (
                          <tr style={{ textAlign: "center" }}>
                            <td colSpan="4">Not found user data.</td>
                          </tr>
                        )}
                        {userListShow.length > 0 &&
                          userListShow.map((user, key) => (
                            <tr key={key}>
                              <td>{`${user.first_name}  ${user.last_name}`}</td>
                              <td className="text-center d-none d-md-table-cell">
                                {user.email}
                              </td>
                              <td className="text-center d-none  d-md-table-cell">
                                {user.tel || "-"}
                              </td>
                              <td className="text-center d-none  d-lg-table-cell">
                                {user.agent_name || "-"}
                              </td>
                              <td className="text-center">
                                <UncontrolledDropdown direction="left">
                                  <DropdownToggle
                                    color="white"
                                    className="btn font-size-16 btn-link text-muted mt-n2"
                                  >
                                    <i className="mdi mdi-dots-horizontal"></i>
                                  </DropdownToggle>

                                  <DropdownMenu className="dropdown-menu-end">
                                    <DropdownItem
                                      className="dropdown-item"
                                      onClick={() => handleEditUser(user)}
                                    >
                                      Edit
                                    </DropdownItem>
                                    <DropdownItem
                                      className="dropdown-item"
                                      onClick={() =>
                                        handleResetPasswordUser(user)
                                      }
                                    >
                                      Reset Password
                                    </DropdownItem>
                                    {currentUser &&
                                      currentUser.uid !== user.uid && (
                                        <>
                                          <div className="dropdown-divider"></div>
                                          <DropdownItem
                                            className="dropdown-item"
                                            onClick={() =>
                                              handleDeleteUser(user)
                                            }
                                          >
                                            Delete
                                          </DropdownItem>
                                        </>
                                      )}
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              </td>
                            </tr>
                          ))}
                      </React.Fragment>
                    )}
                  </tbody>
                </Table>

                <Paginate
                  ref={paginateRef}
                  page={page}
                  totalPage={totalPage}
                  pageSize={pageSize}
                  onSetPage={value => dispatch(setUserPage(value))}
                  onSetTotalPage={value => dispatch(setUserTotalPage(value))}
                  onPageChange={() => sliceUserListShow()}
                  dataList={isSearch ? userSearchList : userList}
                  loading={loading}
                />
              </div>
            </CardBody>
          </Card>

          <Modal isOpen={modalConfirmDelete} centered={true}>
            <div className="modal-header">
              <h5 className="modal-title mt-0">Confirm Delete</h5>
              <button
                type="button"
                onClick={() => {
                  setModalConfirmDelete(false)
                }}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                disabled={loadingSubmit}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {userError ? <Alert color="danger">{userError}</Alert> : null}

              <div
                className="mb-3 mt-3"
                style={{ wordWrap: "break-word", wordBreak: "break-all" }}
              >
                <span>Delete User</span>
                <h4 className="text-danger">
                  {modelUser.first_name + " " + modelUser.last_name} ?
                </h4>
              </div>
              <div className="mb-2 row">
                <div className="col-6">
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => {
                      toggleModalConfirmDelete()
                    }}
                    disabled={loadingSubmit}
                  >
                    Cancel
                  </button>
                </div>
                <div className="col-6 text-end">
                  <button
                    className="btn btn-danger"
                    onClick={() => handleDeleteUserSubmit()}
                    disabled={loadingSubmit}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(UserList)
